import React from 'react';
import { Bold, Italic, Pilcrow, List as ListIcon } from 'lucide-react';

const HtmlToolbar = ({ textareaRef, onValueChange }) => {
    const insertTag = (tag, isList = false) => {
        const textarea = textareaRef.current;
        if (!textarea) return;

        const start = textarea.selectionStart;
        const end = textarea.selectionEnd;
        const text = textarea.value;
        const selectedText = text.substring(start, end);
        let newText;
        let cursorOffset = tag.length + 2; // for <tag>

        if (isList) {
            if (tag === 'ul' || tag === 'ol') {
                const listItems = selectedText.split('\n').map(item => `  <li>${item.trim() || 'List item'}</li>`).join('\n');
                newText = `${text.substring(0, start)}<${tag}>\n${listItems}\n</${tag}>${text.substring(end)}`;
                if (selectedText) {
                    cursorOffset = tag.length + 2 + 6;
                } else {
                    cursorOffset = tag.length + 2 + 6;
                }
            } else { // 'li'
                newText = `${text.substring(0, start)}<li>${selectedText || 'List item'}</li>${text.substring(end)}`;
                cursorOffset = 4;
            }
        } else if (tag === 'p') {
            newText = `${text.substring(0, start)}<p>${selectedText || ''}</p>${text.substring(end)}`;
            cursorOffset = 3;
        }
        else { // strong, em
            newText = `${text.substring(0, start)}<${tag}>${selectedText}</${tag}>${text.substring(end)}`;
        }

        onValueChange(newText);

        setTimeout(() => {
            textarea.focus();
            if (selectedText) {
                textarea.setSelectionRange(start + cursorOffset, start + cursorOffset + selectedText.length);
            } else {
                if (tag === 'p' && !selectedText) {
                    textarea.setSelectionRange(start + 3, start + 3);
                } else if (tag === 'li' && !selectedText) {
                    textarea.setSelectionRange(start + 4, start + 4 + 'List item'.length);
                } else if ((tag === 'ul' || tag === 'ol') && !selectedText) {
                    textarea.setSelectionRange(start + tag.length + 2 + 6, start + tag.length + 2 + 6 + 'List item'.length);
                }
                else {
                    textarea.setSelectionRange(start + cursorOffset, start + cursorOffset);
                }
            }
        }, 0);
    };

    return (
        <div className="flex space-x-1 mb-1 p-1 bg-slate-100 rounded-md border border-slate-200">
            <button type="button" onClick={() => insertTag('p')} className="p-1.5 hover:bg-slate-200 rounded text-xs" title="Paragraph"><Pilcrow size={14} /></button>
            <button type="button" onClick={() => insertTag('strong')} className="p-1.5 hover:bg-slate-200 rounded text-xs font-bold" title="Bold"><Bold size={14} /></button>
            <button type="button" onClick={() => insertTag('em')} className="p-1.5 hover:bg-slate-200 rounded text-xs italic" title="Italic"><Italic size={14} /></button>
            <button type="button" onClick={() => insertTag('ul', true)} className="p-1.5 hover:bg-slate-200 rounded text-xs" title="Unordered List"><ListIcon size={14} /></button>
            <button type="button" onClick={() => insertTag('li', true)} className="p-1.5 hover:bg-slate-200 rounded text-xs" title="List Item">LI</button>
        </div>
    );
};

export default HtmlToolbar;